var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.145 1.005c-17.198 0-31.14 13.942-31.14 31.14s13.942 31.14 31.14 31.14c17.199 0 31.14-13.942 31.14-31.14 0-17.199-13.941-31.14-31.14-31.14zm0 58.262c-14.9 0-27.122-12.061-27.122-27.122 0-14.9 12.061-27.122 27.122-27.122 14.9 0 27.122 12.06 27.122 27.122 0 14.9-12.06 27.122-27.122 27.122zM49.93 24.741l-22.662 22.48a1.507 1.507 0 01-2.131-.008l-10.783-10.87a1.507 1.507 0 01.008-2.131l1.07-1.061a1.507 1.507 0 012.13.008l8.662 8.731 20.523-20.358a1.507 1.507 0 012.13.009l1.062 1.07c.586.59.582 1.544-.009 2.13z",
    fill: "#49BC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.6a1f7c275bf68c30b8fc8315e22823c6.svg";
export { ForwardRef as ReactComponent };